module.exports = __webpack_public_path__ + "media/bootstrap-icons/hourglass-top-e895f91b.svg";